import axios from '../../axios'

/*
 * 菜单数据接口
 */

// 登录
export const getMenuList = (data) => {
    return axios({
        url: '/api/admin/menuList',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/menu.js